class LoadingController {
  constructor() {
  }
}

export default LoadingController;



// WEBPACK FOOTER //
// ./client/app/components/loading/loading.controller.js